module.exports = __webpack_public_path__ + "img/wangyi.804611f.png";


//////////////////
// WEBPACK FOOTER
// ./static/wangyi.png
// module id = 9jQg
// module chunks = 14